module.exports = __webpack_public_path__ + "img/main.cb359a11.png";